/**
 * @fileoverview ScreenContainer component for responsive screen rendering
 * @module screen-view-v2/components/shared/ScreenContainer
 *
 * Wraps all screen type components and handles:
 * - Responsive sizing to fit any parent container
 * - Proportional scaling via CSS transform
 * - Overflow handling
 */

import React, { memo } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import styles from './ScreenContainer.module.css';

export interface ScreenContainerProps {
  children?: ReactNode;
  scale?: number;
  className?: string;
  'data-testid'?: string;
}

export const ScreenContainer = memo(function ScreenContainer({
  children,
  scale = 1.0,
  className,
  'data-testid': testId,
}: ScreenContainerProps): React.ReactElement {
  const innerStyle: CSSProperties = {
    transform: `scale(${scale})`,
    transformOrigin: 'top left',
  };

  return (
    <div
      className={className ? `${styles.screenContainer} ${className}` : styles.screenContainer}
      data-testid={testId}
    >
      <div style={innerStyle}>{children}</div>
    </div>
  );
});

ScreenContainer.displayName = 'ScreenContainer';
